import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnDestroy,
  ViewChild,
  OnInit, ElementRef,
} from "@angular/core";
import { OverviewDisplayComponent } from "@products/overview/overview-display-component.interface";
import { OverviewComponentConfig } from "@products/overview/overview-component.config";
import { Page, Component as BrComponent } from "@bloomreach/spa-sdk/";
import {
  FundHeaderState,
  FundPerformanceTableData,
  FundPerformanceAnnualizedState,
  ProductDetailConfiguration,
  TabName,
  FundId,
} from "@types";
import { BaseProductDetailComponent } from "@products/base-product-detail.component";
import { combineLatest, Subscription } from "rxjs";
import { Logger } from "@utils/logger";
import { FundDocument } from "@components/products/types/fund-document.type";
import { SiteConfigService } from "@services/site-config.service";
import { TranslateService } from "@components/shared/translate/translate.service";
import { FundHeaderService } from "../services/fund-header.service";
import { WINDOW } from "@ng-web-apis/common";
import {
  FundPerformanceAnnualizedService
} from "@components/products/fund-performance/services/fund-performance-annualized.service";
import { getWidenDocumentUrl } from "@utils/link-utils";
import { Meta, SafeHtml } from "@angular/platform-browser";
import { AnalyticsService } from "@services/analytics.service";
import { FundCompareService } from "@components/products/fund-listing/services/fund-compare.service";
import {
  FundCompareDetail
} from "@components/products/fund-listing/fund-compare/fund-compare.type";
import { WatchListService } from "@components/products/fund-listing/services/watch-list.service";
import { CaveatService } from "@components/products/caveats/services/caveat.service";
import { InvestNowService } from "@services/invest-now.service";
import {
  WatchListItem,
} from "@components/products/types/watch-list.type";
import { TitleService } from "@services/title.service";
import { Location } from "@angular/common";
import {
  CircleProgressComponent,
  CircleProgressOptions,
} from "ng-circle-progress";
import {
  FundInformationAdditionalInfo,
  FundInformationNav,
  FundInformationOverview,
} from "@types";
import {
  DateRangeConfigurationCustomRange,
  DropdownOption,
  PricingState,
  PricingStateHighLowNavData,
  PricingStateSelectedDataDateRange,
  PricingStateSelectedTableData,
  PricingStateShareClassInfo,
  ToggleOptionWithPeriod,
} from "@types";
import moment from "moment";
import { PricingService } from "@products/services/pricing.service";
import { FundInformationService } from "../services/fund-information.service";
import { sortShareClasses } from "@components/products/utils/shareclass-sorter";
import cloneDeep from "lodash/cloneDeep";
import { CommonService } from "@services/common.service";
import { Router } from "@angular/router";
import { FundCompareItem } from "@components/products/types/fund-compare.type";
import { EnvConfigService } from "@services/env-config.service";

const logger = Logger.getLogger("FundHeaderComponent");

@Component({
  selector: "ft-fund-header",
  templateUrl: "./fund-header.component.html",
  styleUrls: ["./fund-header.component.scss"],
  providers: [CircleProgressComponent, CircleProgressOptions],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundHeaderComponent
  extends BaseProductDetailComponent
  implements OverviewDisplayComponent, OnInit, OnDestroy {
  @Input() cardType: string;
  dataSubscription: Subscription;
  dataSubscriptions: Subscription[] = [];
  fundDocument: FundDocument;
  sinceInceptionReturn = null;
  navDroopdownValue = null;
  fund: any;
  fundAge: any;
  planBasedExpenseRatio = "";
  navDroopdownName = null;
  isLoaded = false;
  performance: FundPerformanceTableData;
  perfAsOfDate: string;
  perfValue: string = '';
  setPercentValue: string = "100";
  compareListFundsCount: number = 0;
  perfDropdownItems: any = [];
  selectedPerformance: string;
  minimalInvestment: string;
  additionalInvestment: string;

  lastQuarterEndDate: string;
  bannerImage: string;
  bannerImageMobile: string;
  isCompareButtonChecked = false;
  isWatchlistChecked = false;
  fundTitle: string;
  isSegregated: boolean;
  isNFO: boolean;
  watchListFull: boolean = false;
  compareFull: boolean = false;
  nfoImage: string;
  overview: FundInformationOverview;
  fundInformationNav: FundInformationNav;
  additionalInfo: FundInformationAdditionalInfo;
  showTE: boolean;
  showTD: boolean;
  TEData: Array<object> = [];
  TDData: Array<object> = [];
  TEAsofDate: string;
  TDAsofDate: string;
  shareClassArr: Array<string> = [""];
  showCompareErrorDialoge: boolean = false;
  tabs: { label: string; type: TabName }[];
  fundName: string;
  fundincdt: string;
  assetclass: string;
  invfocus: string;
  fundShareClassData: PricingStateShareClassInfo[] = [];
  fundPlans: DropdownOption[];
  timePeriods: DropdownOption[];
  currentDateStd: string;
  customRange: DateRangeConfigurationCustomRange;
  selectedPlan: string;
  selectedFundShareClassData: PricingStateShareClassInfo;
  selectedDataDateRange: PricingStateSelectedDataDateRange;
  selectedHighLowNavData: PricingStateHighLowNavData;
  fundInceptionDate: string;
  selectedTimePeriod: string;
  fundInceptionText: string;
  pricingTableData: PricingStateSelectedTableData[];
  removeCompareDialoge: boolean = false;
  @ViewChild("circleProgress") circleProgress: CircleProgressComponent;
  options: any = [];
  id: string = "top_id";
  fundDetails: any;
  fundNavsAtWindUpDate: any;
  getBenchmarkGraphLumpsumData: any = [];
  getBenchmarkGraphSipData: any = [];
  setBenchmarkGraphDropDownData: any = [];
  showRemoveDialoge: boolean = false;
  selectedPerfPeriodValue = "3 Years";
  isBenchmarkGraph = false;
  productLabel: SafeHtml;
  hasProductLabel = false;
  fundRiskName: string;

  showSaveDialoge = false;
  showCopyDialoge = false;
  showCalcBox = false;
  isHistoricalDataAvailable = false;
  showComparedDialoge: boolean = false;
  isFundInWatchlist: boolean = false;
  isFundInComparelist: boolean = false;
  watchListCount: number = 0;
  focusFunds: any = [];
  badgeValue: string;
  isFocusFund: boolean = false;
  linkToCopy: string;
  dataFlag: boolean = false;

  constructor(
    private _router: Router,
    private changeDetector: ChangeDetectorRef,
    private siteConfig: SiteConfigService,
    private translateService: TranslateService,
    private fundHeaderService: FundHeaderService,
    private annualizedService: FundPerformanceAnnualizedService,
    @Inject(WINDOW) private _window: Window,
    private analyticsService: AnalyticsService,
    private fundCompareService: FundCompareService,
    private watchlistService: WatchListService,
    private metaService: Meta,
    private titleService: TitleService,
    private caveatService: CaveatService,
    private investNowService: InvestNowService,
    private location: Location,
    private cdr: ChangeDetectorRef,
    private fundInformationService: FundInformationService,
    private pricingService: PricingService,
    private commonService: CommonService,
    private watchListService: WatchListService,
    private envConfig: EnvConfigService,
    private elementRef: ElementRef,
  ) {
    super();
  }

  isThisFocusFund(fundId: FundId) {
    if (this.focusFunds) {
      for (const fund of this.focusFunds) {
        if (fund.fundId === fundId) {
          return true;
        }
      }
    }
  }

  async ngOnInit(): Promise<void> {
    this.fundDetails = this.location.getState();
    this.badgeValue = this.translateService.instant("products.focused-funds-badge");
    let focusFunds = this.translateService.instant("products.focused-funds-config");
    const focusFundsArray = focusFunds?.split(",");
    this.focusFunds = focusFundsArray?.map(number => {
      return {"fundId": number};
    });
    this.isFocusFund = this.isThisFocusFund(this.brConfig.fundId);
    // Enable the compare button checkbox, if fund already exist in compare list in local storage.
    try {
      const fundCompareDetails: FundCompareDetail[] =
        await this.fundCompareService.retrieveFundDetailListFromLocalStorage();

      if (
        fundCompareDetails?.find(
          (fundCompareDetail) =>
            fundCompareDetail.fundId === this.brConfig.fundId
        )
      ) {
        this.isCompareButtonChecked = true;
      }
    } catch (error) {
      logger.error("Error in fetching compare details: ", error);
    }

    this.fundCompareService.compareListCount$.subscribe((count) => {
      this.compareListFundsCount = count; // Dynamically getting the count of Compare list funds count
    });
    this.watchListService.watchlistCount$.subscribe((count) => {
      this.watchListCount = count; // Dynamically getting the count of watchlist funds count
    });
  }

  toggleShowSavDialoge() {
    this.showSaveDialoge = !this.showSaveDialoge;
  }

  toggleWatchListDialoge(type: string, fund?: WatchListItem) {
    if (fund && type === "remove") {
      this.watchListService.addToWatchlist(fund);
      this.showRemoveDialoge = !this.showRemoveDialoge;
    }

    if (this.watchListCount < 9) {
      if (type === "add" && fund) {
        this.watchListService.addToWatchlist(fund);
        this.showSaveDialoge = !this.showSaveDialoge;
      } else {
      }
      this.isFundInWatchlist = !this.isFundInWatchlist;
    } else {
      this.watchListFull = !this.watchListFull;
    }

    this.cdr.detectChanges();
    if (type === "add" && fund) {
      this.analyticsService.trackEvent({
        event: 'Event FundPage',
        category: 'Fund Page',
        action: 'Add to Watchlist',
        label: this.fund?.fundName,
      });
    }

  }

  toggleShowComparedDialoge(type: string, fund?: FundCompareItem) {
    if (type === "add" && this.compareListFundsCount === 3) {
      this.compareFull = !this.compareFull;
      return
    }
    if (fund) {
      this.fundCompareService.addToCompareList(fund);
    }
    this.isFundInComparelist = !this.isFundInComparelist;
    if (type === "add") {
      this.showComparedDialoge = !this.showComparedDialoge;
    } else if (type === 'remove') {
      this.removeCompareDialoge = !this.removeCompareDialoge;
    }
    if (type === "add") {
      this.analyticsService.trackEvent({
        event: 'Event FundPage',
        category: 'Fund Page',
        action: 'Compare',
        label: this.fund?.fundName,
      });
    }
  }


  routeModuleCompareFund() {
    this.toggleShowComparedDialoge('close');
    let compareUrl = this.translateService.instant("products.fund-listing-compare-url");
    this._router.navigate([compareUrl]);
  }

  routeModuleWatchList() {
    let watchListUrl = this.translateService.instant("products.watch-list-url");
    this._router.navigate([watchListUrl]);
    this.toggleWatchListDialoge('close');
  }

  async toggleShowCopyDialoge(check): Promise<void> {
    //if (check) {
    const url = this.siteConfig.getFundLink(
      this.brConfig.fundId,
      TabName.OVERVIEW,
      this.fundName
    );
    const baseUrl = this.commonService.getBaseUrl();
    this.linkToCopy = `${baseUrl}${url}`;

    try {
      await navigator.clipboard.writeText(this.linkToCopy);
      logger.info('Link copied to clipboard:', this.linkToCopy);
    } catch (err) {
      logger.error('Unable to copy to clipboard', err);
    }
    //}
    this.showCopyDialoge = check;
    this.cdr.detectChanges();
  }

  shareOnApp(appName): void {
    const url = this.siteConfig.getFundLink(
      this.brConfig.fundId,
      TabName.OVERVIEW,
      this.fundName
    );
    this.commonService.shareOn(appName, url);
  }

  moveToPerformance() {
    const elementToScroll = document.getElementById("performance");
    // Scroll to the element with a delay of 10 milliseconds (or any desired delay)
    elementToScroll.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }

  scrollToRiskometer() {
    const elementToScroll = document.getElementById("fund-riskometer");
    if (elementToScroll) {
      // Scroll to the element with a delay of 10 milliseconds (or any desired delay)
      elementToScroll.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }

  populate(
    componentConfig: OverviewComponentConfig,
    brConfig: ProductDetailConfiguration,
    component: BrComponent,
    page: Page
  ) {
    this.initialize(brConfig, component, page);
    if (this.checkFund()) {
      //this.setTabs();
      this.isSegregated = this.siteConfig.isSegregatedFund(
        this.brConfig.fundId
      );
      this.isNFO = this.siteConfig.isNfoFund(this.brConfig.fundId);
      const documents = component.getModels()?.documents;

      this.fundDocument = page.getContent(documents)?.getData<FundDocument>();
      this.bannerImage = getWidenDocumentUrl(
        this.fundDocument?.fundbanner?.bannerImage?.widenDocument
      );
      this.bannerImageMobile = getWidenDocumentUrl(
        this.fundDocument?.fundbannermobile?.bannerImage?.widenDocument
      );
      logger.debug(this.fundDocument);
      this.watchlistService.setWatchListLimit(9);
      this.lastQuarterEndDate = this.fundHeaderService.getEndOfLastQuarter();
      const brUniqueInvestorsDate =
        "products." + this.brConfig.fundId + ".uniqueInvestorsDate";
      const uniqueInvestorsDate = this.translateService.instant(
        brUniqueInvestorsDate
      );
      this.nfoImage = this.translateService.instant(
        "products.fund-header-image-nfo-period"
      );
      if (uniqueInvestorsDate !== "[" + brUniqueInvestorsDate + "]") {
        this.lastQuarterEndDate = uniqueInvestorsDate;
      }
      this.dataSubscription = combineLatest([
        this.watchlistService.isWatchlist$(this.brConfig?.fundId), // To check if this fund is added in watchlist
        this.fundHeaderService.getFundHeaderState$(),
        this.annualizedService.getAnnualizedState$(),
        this.caveatService.getLegals$("FundHeaderFundNameEnd"),
      ]).subscribe(
        (data: any) => {
          // Clear the value in every loop to avoid duplicates.
          this.perfDropdownItems = [];
          let isWatchList: boolean;
          let fhState: FundHeaderState;
          let perfState: FundPerformanceAnnualizedState;
          let caveats: string[];
          [isWatchList, fhState, perfState, caveats] = data;
          this.isWatchlistChecked = isWatchList;
          this.fundName = fhState.fundName;
          //Add
          this.fund = {fundId: this.brConfig.fundId, fundName: this.fundName, assetClass: this.assetclass};
          this.isFundInWatchlist = this.watchListService.isFundInWatchlist(this.fund);
          this.isFundInComparelist = this.fundCompareService.isFundInCompareList(this.fund);
          this.fundincdt = fhState.fundInceptionDate;
          this.assetclass = fhState.assetClass;
          this.invfocus = fhState.investmentFocus;
          this.perfDropdownItems = fhState.perfDropdownItems;

          this.selectedPerformance = this.perfDropdownItems.find(
            (perf) => perf?.selected
          ).value;
          this.minimalInvestment = fhState.minimumInvestment;
          this.additionalInvestment = fhState.additionalInvestment;
          if (!this.isSegregated && perfState.isLoaded) {
            this.isBenchmarkGraph = true;
            this.perfAsOfDate = perfState.perfAsOfDate;
            this.performance = perfState.lumpsumData?.annualizedCurrent?.performance;
            this.sinceInceptionReturn =
              perfState.lumpsumData?.annualizedCurrent?.performance?.sinceInceptionReturn;
            this.perfValue = this.performance?.sinceInceptionReturn;

            /** Condition to check the 15-year dropdown value, if not pushed manually.  */
            const isDropdownItems = this.perfDropdownItems.filter(item => item.value === "year15Return").length > 0;
            if (!isDropdownItems) {
              this.perfDropdownItems.splice(this.perfDropdownItems.length - 1, 0, {
                label: '15 Years',
                value: 'year15Return'
              });
            }

            /**
             * Fetch and Set the Benchmark Graph data
             */
            this.setBenchmarkGraphDropDownData = [];
            this.getBenchmarkGraphSipData = [];
            this.getBenchmarkGraphLumpsumData = [];
            if (
              this.performance &&
              this.getBenchmarkGraphLumpsumData.length === 0
            ) {
              this.performance.bmName = this.translateService.instant("products.performance-annualized-col-header-fund"); //"Fund";
              this.getBenchmarkGraphLumpsumData.unshift(this.performance);
            }

            perfState?.sipData?.forEach(
              (ele, index) => {
                this.getBenchmarkGraphSipData.push(ele);
              }
            );
            perfState?.lumpsumData?.annualizedCurrent?.bmPerformance?.forEach((element, index) => {
              this.getBenchmarkGraphLumpsumData.push(element);
            });

            /**
             * Set default 3 years return value
             */
            this.graphData(this.getBenchmarkGraphSipData);
          }
          this.fundTitle =
            this.fundName + caveats.join(",").replace(/<\/?p>/g, "");
          this.setMetadata();
          this.isLoaded = true;
          this.changeDetector.detectChanges();
        },
        (error) => {
          logger.error(`Error in invoking services: ${error}`);

          this.isLoaded = false;
          this.changeDetector.detectChanges();
        }
      );


      this.annualizedService.populate(this.brConfig);
      this.fundHeaderService.populate(this.brConfig);
      this.changeDetector.detectChanges();
    }

    this.productLabel = this.fundDocument.productlabel;
    this.hasProductLabel = this.fundDocument.productlabel?.length > 0;
    logger.debug(page, this.page);

    this.cdr.detectChanges();

    if (this.brConfig.fundId) {
      this.fundRiskName = this.commonService.getRisk(this.fundDocument.productlabel);
      if (!this.isSegregated) {
        this.dataSubscription = this.fundInformationService
          .getFundInformationState$()
          .subscribe(
            (fundInformationState) => {
              this.isLoaded = fundInformationState.isLoaded;
              if (this.isLoaded) {
                this.overview = fundInformationState.overview;
                this.fundAge = this.overview?.inceptionDate;
                this.fundInformationNav = fundInformationState.nav;
                this.navDroopdownValue =
                  fundInformationState.nav.shareClasses[0]?.nav;
                this.navDroopdownName =
                  fundInformationState.nav.shareClasses[0]?.name;
                this.checkForTeTdData(this.fundInformationNav?.shareClasses);
                this.additionalInfo = fundInformationState.additionalInfo;
                this.expenseRatioForPlan(this.navDroopdownName);
              }
              this.cdr.detectChanges();
            },
            (error) => {
              logger.error(
                `Error in invoking fund information service: ${error}`
              );

              this.isLoaded = false;
              this.cdr.detectChanges();
            }
          );
        this.fundInformationService.populate(brConfig);

        this.dataSubscriptions.push(
          this.pricingService.getPricingState$().subscribe(
            (state) => {
              this.mapState(state);
            },
            (error) => {
              logger.error(`Error in invoking pricing state: ${error}`);

              // Condition when, pricing historical data isn't available.
              if (this.isLoaded) {
                this.isHistoricalDataAvailable = false;
              } else {
                // Initial load, and product details data isn't available.
                this.isLoaded = false;
              }

              this.cdr.detectChanges();
            }
          )
        );
        this.dataSubscriptions.push(
          this.caveatService
            .getLegals$("FundHistoricalNavsAtWindUpDate")
            .subscribe((data) => {
              if (data.length > 0) {// NOSONAR
                try {// NOSONAR
                  this.fundNavsAtWindUpDate = JSON.parse(data[0].replace(/<[^>]*>/g, ""));// NOSONAR
                  this.cdr.detectChanges();
                } catch (e) {
                  logger.error("invalid json in wound up caveat", data[0], e);
                }
              }
            })
        );
        this.pricingService.populate(brConfig);
      }
    }
  }


  /**
   * Functions to show and hide the units and titles based on the negative values
   */
  showTitle(percent) {
    return percent >= 0;
  }

  showSubtitle(val) {
    return val < 0;
  }

  getSubtitle(val) {
    if (val < 0) {
      return val + '%';
    }
  }

  /**
   * Assign values to properties when state changes.
   * @param state state returned by pricing service
   */
  private mapState(state: PricingState): void {
    const dateFormat = 'DD/MM/YYYY';
    this.fundInceptionDate = state.fundInceptionDate;
    this.fundName = state.fundName;
    this.fundShareClassData = state.fundShareClassData;
    this.fundShareClassData = this.fundShareClassData.sort(sortShareClasses);

    this.selectedFundShareClassData = this.fundShareClassData[0];
    this.fundPlans = this.constructFundPlansDropdownOptions(
      this.fundShareClassData
    );
    this.selectedPlan = this.fundPlans[0]?.value;
    this.timePeriods = this.constructPriceRangeDropdownOptions(
      state.tableConfig.dateRangeEnum
    );
    this.selectedTimePeriod = state.tableConfig.selectedToggleRange;

    // Set default value for calendar input.
    this.customRange = state.tableConfig.customRange;
    this.currentDateStd = state.currentDateStd;
    this.fundInceptionText = this.translateService.instant(
      `products.fund-inception-date`
    );
    // }

    // Assign historical properties when there is a fetch call for the same.
    if (state.selectedData) {
      this.selectedHighLowNavData = cloneDeep(state.selectedHighLowNavData);
      this.selectedDataDateRange = cloneDeep(state.selectedDataDateRange);
      this.selectedDataDateRange.startDate = moment(
        state.selectedDataDateRange.startDate
      ).format(dateFormat);
      this.selectedDataDateRange.endDate = moment(
        state.selectedDataDateRange.endDate
      ).format(dateFormat);

      this.isHistoricalDataAvailable = true;
    }

    if (state?.pricingTableData) {
      this.pricingTableData = state?.pricingTableData;
    }

    this.isLoaded = true;
    this.cdr.detectChanges();
    // }
  }

  /**
   * Construct fund plans (share class names) dropdown options with static values.
   * @param dateRangeEnum full date range map
   */
  private constructFundPlansDropdownOptions(
    fundShareClassData: PricingStateShareClassInfo[]
  ): DropdownOption[] {
    return fundShareClassData.map((shareClass) => ({
      value: shareClass.shareClassCode,
      label: shareClass.shareClassName,
    }));
  }

  /**
   * Construct price date range dropdown options with static values.
   * @param dateRangeEnum full date range map
   */
  private constructPriceRangeDropdownOptions(
    dateRangeEnum: Map<string, ToggleOptionWithPeriod>
  ): DropdownOption[] {
    return Array.from(dateRangeEnum.values()).map(
      (dropdownOption: ToggleOptionWithPeriod) => ({
        value: dropdownOption.value,
        label: this.translateService.instant(dropdownOption.text),
        link: "#",
      })
    );
  }

  private checkForTeTdData(shareClasses) {
    if (shareClasses.length) {
      // TE data
      shareClasses.forEach((shareClass) => {
        if (
          shareClass.icradataservice &&
          shareClass.icradataservice.teasofdate
        ) {
          this.TEData.push({
            name: shareClass.name,
            te1year: shareClass.icradataservice.te1year,
          });
          this.showTE = true;
          this.TEAsofDate = moment(
            shareClass.icradataservice.teasofdate
          ).format("DD/MM/YYYY");
        }
        if (
          shareClass.icradataservice &&
          shareClass.icradataservice.tdasofdate
        ) {
          this.shareClassArr.push(shareClass.name);
          this.TDAsofDate = moment(
            shareClass.icradataservice.tdasofdate
          ).format("DD/MM/YYYY");
          this.showTD = true;
        }
      });

      // TD data
      if (this.showTD) {
        let rowArr = [];
        [
          {
            text: "1-Year",
            key: "td1year",
          },
          {
            text: "3-Year",
            key: "td3year",
          },
          {
            text: "5-Year",
            key: "td5year",
          },
          {
            text: "10-Year",
            key: "td10year",
          },
          {
            text: "Since Launch",
            key: "tdsiyear",
          },
        ].forEach((obj) => {
          rowArr = [];
          rowArr.push(obj.text);
          shareClasses.forEach((shareClass) => {
            if (shareClass.icradataservice) {
              rowArr.push(shareClass.icradataservice[obj.key]);
            }
          });
          this.TDData.push(rowArr);
        });
      }
    }
  }

  onfundPlansChange(menu): void {
    this.navDroopdownValue = menu.nav;
    this.navDroopdownName = menu.name;
    this.expenseRatioForPlan(this.navDroopdownName);
  }

  expenseRatioForPlan(planName) {
    if (planName) {
      if (planName.toLowerCase().includes("direct")) {
        this.planBasedExpenseRatio = this.additionalInfo?.expenseRatioDirect;
      } else {
        this.planBasedExpenseRatio = this.additionalInfo?.expenseRatio;
      }
    }
  }

  loadSipData() {
    this.dataFlag = false;
    this.graphData(this.getBenchmarkGraphSipData);
  }

  loadLumpsumData() {
    this.dataFlag = true;
    this.graphData(this.getBenchmarkGraphLumpsumData);
  }

  graphData(data: any) {
    let prefPeriod = '';
    for (let selectedYear of this.perfDropdownItems) {
      if (selectedYear.label === this.selectedPerfPeriodValue) {
        prefPeriod = selectedYear.value;
      }
    }

    this.setBenchmarkGraphDropDownData = [];
    data.forEach((lumsumValue, index) => {
      if (index <= 3) {
        let val;
        if (lumsumValue[prefPeriod] !== "-") {
          val = parseFloat(lumsumValue[prefPeriod]).toFixed(2);
          this.perfValue = ''
        } else {
          if (this.perfValue !== '') {
            this.perfValue = lumsumValue[prefPeriod];
          }
        }
        this.setBenchmarkGraphDropDownData.push({
          bmName: lumsumValue.bmName,
          value: val,
        });
      }
    });
    this.options = [];
    this.options = this.setBenchmarkGraphDropDownData;
  }


  /**
   * Triggered when an option is changed in select dropdown.
   * @param event change event generated from select dropdown
   */
  onPerfPeriodChange(menu): void {
    /**
     *  Set the value for bench mark graph based on the Annualised Returns selection.
     */
    this.setBenchmarkGraphDropDownData = [];
    const selectedPerfPeriod: string = menu.value;
    if (this.dataFlag) {
      this.getBenchmarkGraphLumpsumData.forEach((ele, index) => {
        if (index <= 3) {
          let val;
          if (ele[selectedPerfPeriod] !== "-") {
            val = parseFloat(ele[selectedPerfPeriod]).toFixed(2);
          }
          this.setBenchmarkGraphDropDownData.push({
            bmName: ele.bmName,
            value: val,
          });
        }
      })
    } else {
      this.getBenchmarkGraphSipData.forEach((ele, index) => {
        if (index <= 3) {
          let val;
          if (ele[selectedPerfPeriod] !== "-") {
            val = parseFloat(ele[selectedPerfPeriod]).toFixed(2);
          }
          this.setBenchmarkGraphDropDownData.push({
            bmName: ele.bmName,
            value: val,
          });
        }
      })
    }
    this.options = [];
    this.options = this.setBenchmarkGraphDropDownData;
    switch (selectedPerfPeriod) {
      case "averageAnnualReturnSinceInception":
        this.perfValue = this.performance.sinceInceptionReturn;
        this.setPercentValue = this.performance.sinceInceptionReturn;

        break;
      default:
        this.perfValue = this.performance[selectedPerfPeriod];
        this.setPercentValue = this.performance[selectedPerfPeriod];
    }

    let returnVal = this.setBenchmarkGraphDropDownData.find(n => n.value !== undefined)
    if (returnVal !== undefined) {
      this.perfValue = returnVal.value;
    } else {
      this.perfValue = this.setPercentValue;
    }
    // Tracking analytics on dropdown change of Annualized Returns
    this.analyticsService.trackEvent({
      event: "Event FundPage",
      category: "Fund Page",
      action:
        "Annualised Returns | " + menu.label,
      label: this.fundName,
    });
    this.selectedPerfPeriodValue = menu.label;
    this.changeDetector.detectChanges();
  }

  setMetadata() {
    // Page Meta
    const pageData = this.fundDocument.ftindiaPageMetaData;
    const metaTitle = pageData?.metaTitle
      ? pageData.metaTitle
      : this.fundName + " - Invest Now with Franklin Templeton India";
    const metaKeywords = pageData?.metaKeyword;
    const metaDescription = pageData?.metaDescription;

    this.titleService.setTitle(metaTitle);
    this.metaService.updateTag(
      {name: "keywords", content: metaKeywords ? metaKeywords : ""},
      "name='keywords'"
    );
    this.metaService.updateTag(
      {
        name: "description",
        content: metaDescription ? metaDescription : "",
      },
      "name='description'"
    );
    this.metaService.updateTag(
      {
        property: "og:title",
        content: metaTitle ? metaTitle?.substring(0, 48) + "..." : "",
      },
      "property='og:title'"
    );
    this.metaService.updateTag(
      {
        property: "og:description",
        content: metaDescription ? metaDescription : "",
      },
      "property='og:description'"
    );
    this.metaService.updateTag(
      {
        property: "og:locale",
        content: "en_IN",
      },
      "property='og:locale'"
    );
    this.metaService.updateTag(
      {
        property: "twitter:card",
        content: "summary_large_image",
      },
      "property='twitter:card'"
    );
    this.metaService.updateTag(
      {
        property: "twitter:title",
        content: metaTitle ? metaTitle : "",
      },
      "property='twitter:title'"
    );
    this.metaService.updateTag(
      {
        property: "twitter:image",
        content: "",
      },
      "property='twitter:image'"
    );
    this.metaService.updateTag(
      {
        property: "twitter:description",
        content: metaDescription ? metaDescription : "",
      },
      "property='twitter:description'"
    );
    this.addSchema();
  }

  private addSchema() {
    const urlRoot = this.envConfig.getEnvConfig()?.baseUrl.replace(/\/$/, "");
    const overviewUrl = urlRoot + this.siteConfig.getFundLink(
      this.brConfig.fundId,
      TabName.OVERVIEW,
      this.fundName
    );
    // Page Meta
    const pageData = this.fundDocument?.ftindiaPageMetaData;
    const metaDescription = pageData?.metaDescription;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'InvestmentFund',
      'name': this.fundName,
      'url': overviewUrl,
      'description': metaDescription ? metaDescription : "",
      'identifier': {
        '@type': 'PropertyValue',
        'name': 'Fund Identifier',
        'value': this.brConfig.fundId ? this.brConfig.fundId : "",
      },

      'audience': {
        '@type': 'Audience',
        'audienceType': 'Individual Investors'
      },
      'provider': {
        '@type': 'Organization',
        'name': 'Franklin Templeton India',
        'url': urlRoot
      },
      'isRelatedTo': {
        '@type': 'InvestmentOrDeposit',
        'name': this.fundName ? this.fundName : "",
        'url': overviewUrl
      },
      'amount': {
        '@type': 'MonetaryAmount',
        'currency': 'INR',
        'value': '5000'
      }
    };
    // add to page
    const s = document?.createElement('script');
    s.type = 'application/ld+json';
    s.innerText = JSON.stringify(schema);
    this.elementRef.nativeElement.appendChild(s);
  }

  checkFund(): boolean {
    if (this.siteConfig.isActiveFund(this.brConfig.fundId)) {
      return true;
    }
    this._window.location.href = "/page-not-found";
    return false;
  }

  onInvestNow() {
    this.analyticsService.trackEvent({
      event: "Event FundPage",
      category: "Fund Page",
      action: "Invest Now",
      label: this.fundName,
    });
    this.investNowService.investNow(this.brConfig.fundId);
  }

  closeAddCompareDialoge(type: string) {
    if (type === "close") {
      this.showComparedDialoge = !this.showComparedDialoge;
    }
  }

  closeCompareErrorDialoge(type: string) {
    if (type === "close") {
      this.showCompareErrorDialoge = !this.showCompareErrorDialoge;
    }
  }

  closeRemoveWatchListDialoge(type: string) {
    if (type === "close") {
      this.showRemoveDialoge = !this.showRemoveDialoge;
    }
  }

  closeRemoveCompareDialoge(type: string) {
    if (type === "close") {
      this.removeCompareDialoge = !this.removeCompareDialoge;
    }
  }

  closeCompareOrWatchlistFull(type: string) {
    if (type === "compare") {
      this.compareFull = !this.compareFull;
    }
    if (type === "watchlist") {
      this.watchListFull = !this.watchListFull;
    }
  }

  removeFundString(value: string) {
    if (value) {
      value = value?.replace(/funds|fund/gi, "");
      return value;
    }
    return '';
  }

  shareFund() {
    this.analyticsService.trackEvent({
      event: 'Event FundPage',
      category: 'Fund Page',
      action: 'Share',
      label: this.fund?.fundName,
    });
    this.toggleShowCopyDialoge(false);
  }

  ngOnDestroy(): void {
    this.dataSubscription?.unsubscribe();
    for (const sub of this.dataSubscriptions) {
      sub.unsubscribe();
    }
  }

  protected readonly parseFloat = parseFloat;
  protected readonly Number = Number;
}
